export default __webpack_public_path__ + "static/media/total-monetary-benefits.97ed1cf0.svg";